import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock } from "lucide-react";
import api from "../lib/api";
import { orgJsonLd } from "../lib/seo";
import { Card } from "../components/layout/Page";

// Add a page = add an entry here. ConfigPage renders it on the shared template (hero, sections, cards, buttons, SEO) automatically.
// Fields: path, seo{title,description,robots?,jsonLd?}, hero{eyebrow,title,lead,actions?[{label,to|href,variant?}]},
// sections[{eyebrow?,title?,lead?,body?[...],cards?[{title,lines?,to|href?,cta?}],band?,component?}]

function LocationsList() {
  const [locations, setLocations] = useState([]);
  useEffect(() => { api.get("/locations").then(({ data }) => setLocations(data)).catch(() => {}); }, []);
  return (
    <div className="grid sm:grid-cols-2 gap-5" data-testid="locations-list">
      {locations.filter((loc) => loc.listed !== false).map((loc) => (
        <Card key={loc.id} as={Link} to={`/locations/${loc.slug}`} data-testid={`locations-card-${loc.slug}`} className="block">
          <h3 className="font-bold text-lg" style={{ color: "var(--ut-ink)" }}>{loc.name}</h3>
          <p className="flex items-center gap-2 text-sm mt-3" style={{ color: "var(--ut-muted)" }}><MapPin size={14} style={{ color: "var(--ut-gold)" }} /> {loc.address || `${loc.city || loc.name}, IL — address announced at opening`}</p>
          <p className="flex items-center gap-2 text-sm mt-2" style={{ color: "var(--ut-muted)" }}><Clock size={14} style={{ color: "var(--ut-gold)" }} /> {loc.status && loc.status !== "active" ? "Coming soon" : loc.hours_label}</p>
          <span className="inline-block mt-4 text-sm font-bold" style={{ color: "var(--ut-red)" }}>View location →</span>
        </Card>
      ))}
    </div>
  );
}

export const CONTENT_PAGES = [
  {
    path: "/locations",
    seo: {
      title: "Our Location — 2660 N Halsted St, Lincoln Park Chicago | Urban Turban by VeerGi",
      description: "Urban Turban by VeerGi: Indian and Punjabi restaurant at 2660 N Halsted St, Lincoln Park, Chicago. Dine-in, pickup and delivery, 2–11 PM, closed Tuesdays.",
      jsonLd: orgJsonLd(),
    },
    hero: {
      eyebrow: "Lincoln Park · Chicago",
      title: "Our location",
      lead: "Indian and Punjabi cooking at 2660 N Halsted St, Lincoln Park. Dine in, pick up or get it delivered.",
      actions: [{ label: "Order online", to: "/store/restaurant" }, { label: "Call (312) 955-0331", href: "tel:+13129550331", variant: "ghost" }],
    },
    sections: [{ component: <LocationsList /> }],
  },
];
